/**
 * Application API base URL
 */
let baseURL = process.env.API_BASE_URL || '/api'

export { baseURL }



// WEBPACK FOOTER //
// ./src/api_module/baseURLs.js